(function () {

    'use strict';

    var AssignTagsCtrl = function ($scope, ajaxCall, xmsNotificationFactory, $uibModalInstance, passedModel) {

        console.log('AssignTagsCtrl init!');

        if (!angular.isDefined(passedModel)) {
            passedModel = {};
        }
        $scope.ngModel = passedModel;

        $scope.ok = function () {
            $uibModalInstance.close(this.ngModel);
        };

        $scope.cancel = function (e) {
            if (angular.isDefined(e)) {
                e.preventDefault();
            }
            $uibModalInstance.dismiss('cancel');
        };

        $scope.init = function(data) {
            var ajaxUrl = WEBAPP_PATH + "/tagAdmin/getSelectedAssignTags";
            ajaxCall.getData(ajaxUrl, data).then(function(result) {
                if (result.data.success == true) {
                    $scope.ngModel.tags = result.data.response.returnList;
                    var tagString = "";
                    angular.forEach($scope.ngModel.tags, function(tag){
                        tagString += tag.name + ",";
                    });
                    $scope.ngModel.tagString = tagString;
                    if(result.data.response.tagOwner != null) {
                        $scope.ngModel.tagOwner = result.data.response.tagOwner;
                    }
                    $scope.ngModel.isFiltered = result.data.response.isFiltered;
                    $scope.getAllOrganisationUnit(result.data.response.selectedOrgUnit, data);
                    $scope.ngModel.selectedOptions = {"orgUnit": result.data.response.selectedOrgUnit, "tagOwner": result.data.response.tagOwner};
                }
            }, function(result) {
                xmsNotificationFactory.bulk("Error: Unable to process your request", "danger");
                console.log("Error in AssignTagsCtrl.js", result);
            });
        };

        $scope.tagKeypress = function(e) {
            if (angular.isDefined(e)) {
                e.preventDefault();
            }
            return false;
        };

        $scope.getAllOrganisationUnit = function(selectedOrgUnit, data) {
            var ajaxUrl = WEBAPP_PATH + "/tagAdmin/getAllOrganisationUnit";
            ajaxCall.getData(ajaxUrl, data).then(function(result) {
                if (result.data.success == true) {
                    $scope.ngModel.orgUnits = result.data.response.orgUnits;
                    $scope.ngModel.orgUnit = selectedOrgUnit;
                    if(selectedOrgUnit != null) {
                        $scope.orgUnitChange(selectedOrgUnit);
                    }
                }
            }, function(result) {
                xmsNotificationFactory.bulk("Error: Unable to process your request", "danger");
                console.log("Error in AssignTagsCtrl.js", result);
            });
        };

        $scope.getPersonsByOrganisationUnit = function(orgUnitId) {
            var ajaxUrl = WEBAPP_PATH + "/tagAdmin/getPersonsByOrganisationUnit/" + orgUnitId;
            ajaxCall.getData(ajaxUrl).then(function(result) {
                if (result.data.success == true) {
                    $scope.ngModel.tagOwners = result.data.response.persons;
                }
            }, function(result) {
                xmsNotificationFactory.bulk("Error: Unable to process your request", "danger");
                console.log("Error in AssignTagsCtrl.js", result);
            });
        };

        $scope.orgUnitChange = function(orgUnitId) {
            $scope.ngModel.tagOwners = [];
            $scope.getPersonsByOrganisationUnit(orgUnitId);
        };

        $scope.save = function ($event) {
            $event.preventDefault();
            console.log('AssignTagsCtrl save!');
            if($scope.ngModel.tags == null || $scope.ngModel.tags == '' || ($scope.ngModel.selectedOptions.orgUnit == $scope.ngModel.orgUnit && $scope.ngModel.selectedOptions.tagOwner == $scope.ngModel.tagOwner)) {
                $scope.cancel();
                return false;
            }
            if($scope.ngModel.orgUnit > 0 && $scope.ngModel.tagOwner > 0) {
                var data = "orgUnit=" + $scope.ngModel.orgUnit;
                data += "&tagOwner=" + $scope.ngModel.tagOwner;
                angular.forEach($scope.ngModel.tags, function (value, key) {
                    data += "&selectedTagId=" + value.id;
                });
                var ajaxUrl = WEBAPP_PATH + "/tagAdmin/assignSelectedTags";
                ajaxCall.getData(ajaxUrl, data).then(function(result) {
                    if (result.data.success == true) {
                        if(result.data.response.type == "success") {
                            if(new String($scope.ngModel.redirectURL).indexOf("?") == -1) {
                                window.location.href = $scope.ngModel.redirectURL + "?alertType=" + result.data.response.type + "&alertMessage=" + result.data.response.message;
                            } else {
                                window.location.href = $scope.ngModel.redirectURL + "&alertType=" + result.data.response.type + "&alertMessage=" + result.data.response.message;
                            }
                        } else {
                            xmsNotificationFactory.bulk(result.data.response.message, result.data.response.type);
                        }
                        $scope.cancel();
                    }
                }, function(result) {
                    xmsNotificationFactory.bulk("Error: Unable to process your request", "danger");
                    console.log("Error in AssignTagsCtrl.js", result);
                });
            }
            return false;
        };
    };

    AssignTagsCtrl.$inject = ['$scope', 'ajaxCall', 'xmsNotificationFactory', '$uibModalInstance', 'params'];
    angular.module('app').controller('AssignTagsCtrl', AssignTagsCtrl);

}());